import { ListItemText, ListItem, Stack, Typography, List } from '@mui/material';
import { newUUID } from '@vy/utils';

export const RenewContractSameTermsStepDetails: React.FC = () => {
  const details = getRenewContractSameTermsStepDetails();

  return (
    <Stack
      sx={{
        justifyContent: "center",
        alignItems: "center"
      }}>
      <Stack
        direction="column"
        sx={{
          width: "594px",
          alignItems: "flex-start",
          gap: "8px"
        }}>
        <Typography variant="subtitle1" sx={{
          fontWeight: 600
        }}>
          Start a new contract based on previous contract terms & products
        </Typography>

        <List dense disablePadding sx={{ listStyleType: 'disc', pl: 2 }}>
          {details.map((detail) => (
            <ListItem key={newUUID()} disablePadding sx={{ py: 0.5, display: 'list-item' }}>
              <ListItemText
                primary={
                  <Typography variant="body2" sx={{
                    color: "text.primary"
                  }}>
                    {detail}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      </Stack>
    </Stack>
  );
};

function getRenewContractSameTermsStepDetails() {
  return [
    'Start a new contract after the current one ends',
    'Adjust pricing, update products and commercials',
    'You can update and modify start date, billing interval and duration to the new renewed contract',
  ];
}
